var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewBackground(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1670,
    height: 527,
    viewBox: "0 0 1670 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_741_4918)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 1590,
    height: 447,
    rx: 40,
    fill: "#FFDC9C",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1311.32 436.154C1311.29 432.974 1308.5 430.583 1305.1 430.814C1301.7 431.044 1298.97 433.808 1299 436.988C1299.04 440.167 1301.82 442.559 1305.23 442.328C1308.63 442.098 1311.36 439.334 1311.32 436.154Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.94 144.662C1437.91 142.417 1435.94 140.729 1433.54 140.891C1431.14 141.054 1429.22 143.005 1429.24 145.25C1429.27 147.495 1431.23 149.183 1433.63 149.02C1436.03 148.858 1437.96 146.906 1437.94 144.662Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.26 312.855C1385.23 309.676 1382.44 307.285 1379.04 307.515C1375.64 307.745 1372.91 310.509 1372.94 313.689C1372.98 316.869 1375.76 319.26 1379.17 319.03C1382.57 318.799 1385.3 316.035 1385.26 312.855Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.79 304.616C1324.77 303.119 1323.46 301.994 1321.86 302.102C1320.26 302.211 1318.97 303.512 1318.99 305.008C1319.01 306.505 1320.32 307.63 1321.92 307.522C1323.52 307.413 1324.8 306.112 1324.79 304.616Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.52 435.613C1073.5 434.116 1072.19 432.991 1070.59 433.099C1068.99 433.208 1067.71 434.509 1067.72 436.005C1067.74 437.502 1069.05 438.627 1070.65 438.519C1072.25 438.41 1073.54 437.109 1073.52 435.613Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.15 272.219C1485.11 269.039 1482.33 266.648 1478.93 266.878C1475.52 267.108 1472.8 269.872 1472.83 273.052C1472.87 276.232 1475.65 278.623 1479.05 278.393C1482.45 278.163 1485.18 275.398 1485.15 272.219Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.47 386.155L1324.57 373.017",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M976.857 390.514L987.861 401.767",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1450.02 409.715L1469.6 416.457",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1491.1 54.3594L1508.19 42.0706",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.69 434.335L1154.8 418.68",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.44 188.659L1382.61 198.996",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.756 46.5529C329.742 49.7524 332.486 52.2305 335.885 52.0878C339.284 51.9452 342.051 49.2358 342.065 46.0364C342.078 42.8369 339.334 40.3588 335.935 40.5014C332.536 40.6441 329.769 43.3534 329.756 46.5529Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.317 335.458C197.308 337.717 199.245 339.466 201.645 339.366C204.044 339.265 205.997 337.352 206.007 335.094C206.017 332.835 204.079 331.086 201.68 331.186C199.28 331.287 197.327 333.2 197.317 335.458Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.358 168.344C253.344 171.543 256.088 174.021 259.487 173.879C262.886 173.736 265.653 171.027 265.667 167.827C265.68 164.628 262.936 162.15 259.537 162.292C256.138 162.435 253.371 165.144 253.358 168.344Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M313.649 177.813C313.643 179.319 314.934 180.485 316.534 180.418C318.133 180.351 319.436 179.076 319.442 177.57C319.448 176.064 318.157 174.898 316.557 174.965C314.957 175.032 313.655 176.308 313.649 177.813Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M567.492 51.8817C567.486 53.3875 568.777 54.5538 570.377 54.4866C571.977 54.4195 573.279 53.1444 573.285 51.6386C573.292 50.1328 572 48.9665 570.4 49.0337C568.801 49.1008 567.499 50.3759 567.492 51.8817Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.677 206.969C152.663 210.168 155.407 212.646 158.806 212.504C162.205 212.361 164.972 209.652 164.985 206.452C164.999 203.253 162.255 200.775 158.856 200.917C155.457 201.06 152.69 203.769 152.677 206.969Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M329.558 96.5928L315.269 109.447",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M663.225 98.9586L652.451 87.4221",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.541 70.2919L171.107 63.0556",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.317 424.699L125.041 436.644",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M490.266 51.6279L485.923 67.1982",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M267.673 292.929L253.718 282.229",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_741_4918",
    x: 0,
    y: 0,
    width: 1670,
    height: 527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_741_4918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_741_4918",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBackground);
export default __webpack_public_path__ + "static/media/ReviewBackground.cbca23c05180ca429b184bb7ccf59d79.svg";
export { ForwardRef as ReactComponent };